import { render, staticRenderFns } from "./TabsSelector.vue?vue&type=template&id=74986da4&scoped=true"
import script from "./TabsSelector.vue?vue&type=script&lang=js"
export * from "./TabsSelector.vue?vue&type=script&lang=js"
import style0 from "./TabsSelector.vue?vue&type=style&index=0&id=74986da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74986da4",
  null
  
)

export default component.exports